export default __webpack_public_path__ + "static/media/yz.777b21ed.png";